import { ArrayV2 } from "../../util/ArrayV2";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { Global } from "../Global";
import { DataUtil } from "../util/Util";

type ICicloEscolar = Entidad.ICicloEscolar;
type IEscuela = Entidad.IEscuela;
type IPeriodo = Entidad.ICicloEscolarPeriodo;

export const _DICC_CICLO_ESCOLAR: Map<number, ICicloEscolar> = new Map();

const REQUESTID = Entidad.CTipoRequest.CicloEscolar;

export async function _SvCicloEscolarObtenerLista(kinders: Array<IEscuela>): Promise<DataDRequest.IRequestResponseListA<Entidad.ICicloEscolar>[]> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "cicloEscolar/ObtenerLista";
    return new ArrayV2()
        ._Push(...kinders)
        ._MapAwait(async ({ IdKinder }) => {
            const currentDateStr = await DataUtil._GetMaxDate(REQUESTID, IdKinder);
            const params = {
                "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
                "Modificacion": currentDateStr,
                "IdEscuela": IdKinder,
            }
            return DataDRequest._Request4List(url, "GET", params, REQUESTID, IdKinder);
        })
}

export async function _SvCicloEscolarNuevo(datoCE: Pick<Entidad.ICicloEscolar, "Nombre" | "FechaInicio" | "FechaFin" | "IdEscuela" | "Periodos">): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "cicloEscolar/Nuevo";
    const params = {
        "Nombre": datoCE.Nombre,
        "Inicio": datoCE.FechaInicio,
        "Fin": datoCE.FechaFin,
        "IdEscuela": datoCE.IdEscuela,
        "Periodos": datoCE.Periodos,
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5(url, "POST", params, REQUESTID);
}

export async function _SvCicloEscolarEliminar(idCicloEscolar: number, idEscuela: number): Promise<DataDRequest.IResultadoPeticion<undefined>> {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "cicloEscolar/Eliminar";
    const params = {
        "IdCiclo": idCicloEscolar,
        "IdEscuela": idEscuela,
        "IdUsuario": DataUtil._Usuario.IdUsuario
    }
    return DataDRequest._Request5(url, "POST", params, REQUESTID);
}

export interface IEditarCicloEscolarExtraInfo {
    IdsPeriodosAgregados: number[];
    IdsPeriodosActualizados: number[];
    IdsPeriodosEliminados: number[];
}

export async function _SvCicloEscolarEditar(datoCE: Pick<Entidad.ICicloEscolar, "Id" | "Nombre" | "FechaInicio" | "FechaFin">, periodosAdd: IPeriodo[], periodsEdit: IPeriodo[], periodsDelIds: number[]) {
    const url = Global._GLOBAL_CONF.URL_RSTV2 + "cicloEscolar/Editar";
    const params = {
        "IdCiclo": datoCE.Id,
        "Nombre": datoCE.Nombre,
        "Inicio": datoCE.FechaInicio,
        "Fin": datoCE.FechaFin,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "PeriodosAgregar": periodosAdd,
        "PeriodosEditar": periodsEdit,
        "PeriodosEliminarIds": periodsDelIds
    }

    return DataDRequest._Request5<undefined, IEditarCicloEscolarExtraInfo>(url, "POST", params, REQUESTID);
}
